import React, { useEffect, useState, useCallback } from "react";
import api from "../helpers/api";
import { motion, AnimatePresence } from "framer-motion";
import { formatCreatedDate, urgencyColors, workstatusOptions } from "../constants/utils";
import { Card, CardBody, CardHeader, Modal, Row, Col, Input, Button, Spinner, Badge } from "reactstrap";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import FeatherIcon from "feather-icons-react";
import * as XLSX from "xlsx";
import FileModal from "../components/Common/importExportModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DetailsModal from "../components/DetailsModal";
import TicketDetailsModal from "../components/TicketDetailsModal";
import ReportedByModal from "../components/ReportedByModal";
import { MdSort } from "react-icons/md";
import TechnicianModal from "../components/TechnicianModal";
import PermissionGuard from '../components/Common/PermissionGuard';


const Transactions = () => {
  document.title = "Work Orders | ArcMedix";
  const [organizations, setOrganizations] = useState(null);
  const [technicians, setTechnicians] = useState(null);
  const [locations, setLocations] = useState([]);
  const [organizationId, setOrganizationId] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [modal_large, setmodal_large] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const [sortModal, setSortModal] = useState(false);
  const [sortCriteria, setSortCriteria] = useState({
    field: 'urgencyLevel',
    direction: 'desc'
  });

  const [dateRangeModal, setDateRangeModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState({
    isOpen: false,
    type: null,
    title: '',
    mainData: null,
    relatedData: [],
    loading: false
  });
  const [ticketModal, setTicketModal] = useState({
    isOpen: false,
    ticketData: null,
    loading: false
  });
  const [reportedByModal, setReportedByModal] = useState({
    isOpen: false,
    userData: null,
    loading: false
  });
  const [count, setCount] = useState(10);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [enumData, setEnumData] = useState([]);
  const [fileModal, setFileModal] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [technicianModal, setTechnicianModal] = useState({
  isOpen: false,
  technicianData: null,
  loading: false
});
  const [filters, setFilters] = useState({
    status: "",
    impactOnCare: "",
    issueType: "",
    urgencyLevel: "",
    symptomsTags: "",
    usageStatus: "",
    organizationLocation: "",
  });

  const [dropdownOpen, setDropdownOpen] = useState({});

  const toggleDropdown = (ticketId) => {
    setDropdownOpen(prev => ({
      ...prev,
      [ticketId]: !prev[ticketId]
    }));
  };

  const handlePriorityChange = async (transaction, newPriority) => {
  try {
    await api.put("asset-issues/update", {
      id: transaction.id,
      urgencyLevel: newPriority,
    });
    fetchAssetIssueFromOrganization();
  } catch (error) {
    console.error("Failed to update priority:", error);
  }
};

const handleTechnicianClick = async (technicianId) => {
  if (!technicianId) return;

  setTechnicianModal(prev => ({
    ...prev,
    isOpen: true,
    technicianData: null,
    loading: true
  }));

  try {
    const { data: technicianData } = await api.get(`user/get-all?id=${technicianId}`);
    const { data: ticketsData } = await api.get(`asset-issues/organization/filtered`, {
      params: { 
        assignedTechnician: technicianId,
        count: 5
      }
    });

    setTechnicianModal(prev => ({
      ...prev,
      technicianData: {
        ...technicianData.response[0],
        assignedTickets: ticketsData.response || []
      },
      loading: false
    }));
  } catch (error) {
    console.error('Error fetching technician details:', error);
    setTechnicianModal(prev => ({ ...prev, loading: false }));
  }
};

  const fetchTechnicians = async () => {
    try {
      setLoading(true);
      // Uses RBAC user_roles table via user/technicians endpoint
      const { data } = await api.get('user/technicians');
      setTechnicians(data.response || []);
    } catch (error) {
      console.error('Error fetching technicians:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`asset-issues/delete?id=${selectedEntry?.id}`);
      fetchAssetIssueFromOrganization();
      setDeleteModal(false);
    } catch (error) {
      console.error("Error deleting user:", error);
      setApiError("Failed to delete user");
    }
  };

  const onStatusChange = async (data, value) => {
    try {
      const payload = { id: data?.id, status: value };
      const response = await api.put('asset-issues/update', payload);
      fetchAssetIssueFromOrganization()
    } catch (error) {
      console.error('Failed to update status:', error);
    }
  };

  const getStatusBadge = (status) => {
    const option =
      workstatusOptions.find((opt) => opt.value === status) || {
        label: status,
        icon: 'help-circle',
        colorClass: 'bg-secondary text-white',
        borderColor: '#6c757d', // default secondary border
      };

    return (
      <span
        className={`badge rounded-pill py-1 px-2 d-flex align-items-center gap-1 ${option.colorClass}`}
        style={{ border: `1px solid ${option.borderColor}` }}
      >
        <FeatherIcon icon={option.icon} size={12} />
        {option.label}
      </span>
    );
  };

  // Helper function to get enum values by name
  const getEnumValues = (enumName) => {
    const enumItem = enumData.find(item => item.name === enumName);
    return enumItem ? enumItem.values : [];
  };

  const handleDetailsClick = async (type, data, contextData = null) => {
    setDetailsModal(prev => ({
      ...prev,
      isOpen: true,
      type,
      title: type === 'asset' ? 'Asset Details' : 
            type === 'organization' ? 'Organization Details' : 'Location Details',
      mainData: type === 'location' ? data : data,
      relatedData: [],
      loading: true,
      contextData
    }));

    try {
      const params = {};
      if (type === 'asset') params.assetId = data.id;
      if (type === 'organization') params.organizationId = data.id;
      if (type === 'location') params.organizationLocation = data;

      const { data: response } = await api.get('asset-issues/organization/filtered', { params });
      
      setDetailsModal(prev => ({
        ...prev,
        relatedData: response.response || [],
        loading: false
      }));
    } catch (error) {
      console.error('Error fetching details:', error);
      setDetailsModal(prev => ({ ...prev, loading: false }));
    }
  };

  const tog_large = (entry = null) => {
    setmodal_large(!modal_large);
    setSelectedEntry(entry || null);
    setErrors({});
    setApiError('');
  };

  const handleReportedByClick = async (userId) => {
    if (!userId) return;

    setReportedByModal(prev => ({
      ...prev,
      isOpen: true,
      userData: null,
      loading: true
    }));

    try {
      const { data: userData } = await api.get(`user/get-all?id=${userId}`);
      const { data: issuesData } = await api.get(`asset-issues/organization/filtered`, {
        params: { 
          organizationId,
          reportedBy: userId,
          count: 5
        }
      });

      setReportedByModal(prev => ({
        ...prev,
        userData: {
          ...userData.response[0],
          reportedIssues: issuesData.response || []
        },
        loading: false
      }));
    } catch (error) {
      console.error('Error fetching reported by details:', error);
      setReportedByModal(prev => ({ ...prev, loading: false }));
    }
  };

const handleUpdate = async () => {
  setApiError('');
  try {
    // Prepare the data in the required format
    const payload = {
      id: selectedEntry.id,
      issueType: Array.isArray(selectedEntry.issueType) 
        ? selectedEntry.issueType 
        : [selectedEntry.issueType],
      symptomsTags: Array.isArray(selectedEntry.symptomsTags) 
        ? selectedEntry.symptomsTags 
        : [selectedEntry.symptomsTags],
      errorCode: selectedEntry.errorCode,
      impactOnCare: selectedEntry.impactOnCare,
      usageStatus: selectedEntry.usageStatus,
      urgencyLevel: selectedEntry.urgencyLevel,
      description: selectedEntry.description,
      status: selectedEntry.status,
      firstOccurrence: selectedEntry.firstOccurrence || new Date().toISOString(),
      preferredTechnician: selectedEntry.preferredTechnician?.id || selectedEntry.preferredTechnician,
      assignedTechnician: selectedEntry.assignedTechnician?.id || selectedEntry.assignedTechnician,
      imageUrls: selectedEntry.imageUrls || [],
      documentUrls: selectedEntry.documentUrls || []
    };

    const { data } = await api.put(`asset-issues/update`, payload);
    fetchAssetIssueFromOrganization();
    handleModalClose();
  } catch (error) {
    setApiError(error?.response?.data?.error || "Something went wrong!");
  }
}

  const handleTicketClick = async (ticketNumber) => {
    setTicketModal(prev => ({
      ...prev,
      isOpen: true,
      ticketData: null,
      loading: true
    }));

    try {
      const { data } = await api.get(`asset-issues/organization/filtered`, {
        params: { 
          ticket: ticketNumber
        }
      });
      
      setTicketModal(prev => ({
        ...prev,
        ticketData: data.response?.[0] || null,
        loading: false
      }));
    } catch (error) {
      console.error('Error fetching ticket details:', error);
      setTicketModal(prev => ({ ...prev, loading: false }));
    }
  };

  const clearDateRange = () => {
    setFromDate(null);
    setToDate(null);
  };

  const fetchEnums = async () => {
    try {
      const { data } = await api.get("dynamic-enum/get-all");
      setEnumData(data.response || []);
    } catch (error) {
      console.error("Error fetching enums:", error);
    }
  };

  const fetchLocations = async () => {
    const { data } = await api.get(
      `organization-location/get-by-organization-id?organizationId=${organizationId}&count=9999`
    );
    setLocations(data.response[0]?.locations);
  };

  const handleImport = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleExport = () => {
    if (!transactions || transactions.length === 0) return;

    const dataToExport = transactions.map((transaction, index) => ({
      "#": index + 1,
      "Issue Date": formatCreatedDate(transaction?.createdAt),
      "Ticket Number": transaction?.ticketNumber || "",
      "Asset Name": transaction?.asset?.assetName || "",
      "Asset Category": transaction?.asset?.assetCategory || "",
      "Serial Number": transaction?.asset?.serialNumber || "",
      "First Occurrence": formatCreatedDate(transaction?.firstOccurrence),
      "Organization": transaction?.organization?.name || "",
      "Location": transaction?.asset?.currentLocation || transaction?.locationName || "",
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Work Orders");

    XLSX.writeFile(
      wb,
      `work_orders_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };

  const handleOrganizationChange = (e) => {
    setOrganizationId(e.target.value);
    setTransactions([]);
    setCount(10);
    setHasMore(true);
  };

  const fetchOrganizations = async () => {
    const { data } = await api.get("organization/all");
    setOrganizations(data.response);
    if (data.response && data.response.length > 0) {
      setOrganizationId(data.response[0].id);
    }
  };

  const sortTransactions = useCallback((data) => {
    if (!data) return data;
    
    return [...data].sort((a, b) => {
      let valueA, valueB;
      
      switch(sortCriteria.field) {
        case 'createdAt':
        case 'requestDate':
          valueA = new Date(a[sortCriteria.field]);
          valueB = new Date(b[sortCriteria.field]);
          break;
        case 'urgencyLevel':
          const priorityOrder = { 'NONE':1,'LOW': 2, 'MEDIUM': 3, 'HIGH': 4,'SEVERE':5 };
          valueA = priorityOrder[a[sortCriteria.field]] || 0;
          valueB = priorityOrder[b[sortCriteria.field]] || 0;
          break;
        default:
          valueA = a[sortCriteria.field];
          valueB = b[sortCriteria.field];
      }
      
      if (sortCriteria.direction === 'asc') {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });
  }, [sortCriteria]);

  const fetchAssetIssueFromOrganization = useCallback(async () => {
    if (!organizationId) return;

    setLoading(true);
    try {
      const params = {
        organizationId,
        count,
        ...filters,
      };

      if (fromDate) params.fromDate = fromDate.toISOString();
      if (toDate) params.toDate = toDate.toISOString();
      params.search = searchTerm;

      const { data } = await api.get(`asset-issues/organization/filtered`, { params });

      const sortedData = sortTransactions(data.response);
      setTransactions((prev) =>
        count === 10 ? sortedData : [...sortedData]
      );
      setHasMore(data.response.length === count);
    } catch (error) {
      console.error("Error fetching Work Orders:", error);
    } finally {
      setLoading(false);
    }
  }, [organizationId, count, filters, searchTerm, fromDate, toDate, sortTransactions]);

  const loadMore = () => {
    setCount(prevCount => prevCount + 10);
  };

  const handleModalClose = () => {
    setmodal_large(false);
    setSelectedEntry(null);
  };

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setTransactions([]);
    setCount(10);
    setHasMore(true);

    if (term === "") {
      fetchAssetIssueFromOrganization();
    }
  };

  const renderSelectOptions = (enumName) => {
    const values = getEnumValues(enumName);
    return (
      <>
        <option value="">All {enumName.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</option>
        {values.map((value) => (
          <option key={value} value={value}>
            {value.replace(/_/g, ' ')}
          </option>
        ))}
      </>
    );
  };

  useEffect(() => {
    fetchOrganizations();
    fetchEnums();
    fetchTechnicians()
  }, []);

  useEffect(() => {
    if (organizationId) {
      setTransactions([]);
      setCount(10);
      setHasMore(true);
      fetchAssetIssueFromOrganization();
    }
  }, [filters, searchTerm, organizationId, fromDate, toDate]);

  useEffect(() => {
    fetchAssetIssueFromOrganization();
  }, [fetchAssetIssueFromOrganization, count]);

  useEffect(() => {
    if (organizationId) fetchLocations();
  }, [organizationId]);

  const sortedTransactions = sortTransactions(transactions);

  return (
    <div className="page-content mt-4">
      <div className="mb-4 d-flex align-items-center gap-3">
        <motion.div
          className="mb-4 d-flex align-items-center gap-3"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <div
            className="ms-auto"
            style={{ minWidth: "400px", flexGrow: 1, maxWidth: "500px" }}
          >
            <Input
              type="text"
              placeholder="Search work orders..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </motion.div>
      </div>
      <Card>
        <CardHeader>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="card-title text-success mb-0">Work Orders</h3>
            <div className="d-flex align-items-center gap-2">
              <button
                className={`btn p-2 ${fromDate ? 'btn-soft-primary' : 'btn-soft-secondary'}`}
                onClick={() => setDateRangeModal(true)}
                title="Date range filter"
              >
                <FeatherIcon icon="calendar" size={18} />
                {fromDate && (
                  <span className="ms-1">
                    {formatCreatedDate(fromDate)} - {toDate ? formatCreatedDate(toDate) : '...'}
                  </span>
                )}
              </button>

              <button
                className="btn btn-soft-primary p-2"
                onClick={() => setSortModal(true)}
                title="Sort work orders"
              >
               <MdSort size={20} />
              </button>

              <button
                className="btn btn-soft-primary p-2"
                onClick={() => setFilterModal(true)}
                title="Filter assets"
              >
                <FeatherIcon icon="filter" size={18} />
              </button>
              <button
                className="btn btn-soft-info p-2"
                onClick={() => setFileModal(true)}
                title="Import/Export Work Orders"
              >
                <FeatherIcon icon="file-text" size={18} />
              </button>
              <select
                className="form-select form-select-md w-auto"
                value={organizationId || ""}
                onChange={handleOrganizationChange}
              >
                <option value="" disabled>
                  Select Organization
                </option>
                {organizations?.map((organization) => (
                  <option key={organization.id} value={organization.id}>
                    {organization?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <div
            className="table-responsive"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              maxHeight: "calc(100vh - 300px)",
              overflowY: "auto",
            }}
          >
            <table
              className="table table-hover mb-0"
              style={{
                borderSpacing: "0.1rem",
                borderCollapse: "separate",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 1,
                }}
              >
                <tr>
                  <th>#</th>
                  <th>Planning</th>
                  <th 
                    onClick={() => {
                      setSortCriteria(prev => ({
                        field: 'requestDate',
                        direction: prev.field === 'requestDate' && prev.direction === 'desc' ? 'asc' : 'desc'
                      }));
                    }}
                    className="cursor-pointer"
                  >
                    Due Date
                    {sortCriteria.field === 'requestDate' && (
                      <FeatherIcon 
                        icon={sortCriteria.direction === 'asc' ? 'arrow-up' : 'arrow-down'} 
                        size={14} 
                        className="ms-1" 
                      />
                    )}
                  </th>
                  <th>Ticket Number</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>Asset Name</th>
                  <th>Department</th>
                  <th>Serial Number</th> 
                  <th>First Occurrence</th>
                  <th>Organization</th>
                  <th>Location</th>
                  <th>Reported By</th>
                  <th>Assigned Technician</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <AnimatePresence>
                  {sortedTransactions?.map((transaction, ind) => (
                    <motion.tr
                      key={transaction?.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <th scope="row">{ind + 1}</th>
                      <td>
                        {(() => {
                          const dueDate = new Date(transaction?.requestDate);
                          const today = new Date();
                          today.setHours(0, 0, 0, 0); // Normalize today's date
                          
                          if (dueDate < today) {
                            return (
                              <Badge color="warning" pill className="py-1 px-2">
                                <FeatherIcon icon="alert-triangle" size={12} className="me-1" />
                                Overdue
                              </Badge>
                            );
                          } else {
                            return (
                              <Badge color="success" pill className="py-1 px-2">
                                <FeatherIcon icon="check-circle" size={12} className="me-1" />
                                On track
                              </Badge>
                            );
                          }
                        })()}
                      </td>
                      <td>{formatCreatedDate(transaction?.requestDate)}</td>
                      <td>
                        <span 
                          className="text-primary cursor-pointer hover-underline"
                          onClick={() => handleTicketClick(transaction.ticketNumber)}
                          style={{ cursor: 'pointer' }}
                        >
                          {transaction?.ticketNumber}
                        </span>
                      </td>
                      <td>
                      <Dropdown 
                        isOpen={dropdownOpen[transaction?.ticketNumber] || false} 
                        toggle={() => toggleDropdown(transaction?.ticketNumber)}
                        direction="down"
                      >
                        <DropdownToggle 
                          tag="div" 
                          className="d-inline-block"
                          style={{ cursor: 'pointer' }}
                        >
                          {getStatusBadge(transaction?.status)}
                        </DropdownToggle>
                        <DropdownMenu container="body">
                          {workstatusOptions.map((option) => (
                            <DropdownItem 
                              key={option.value}
                              className="d-flex align-items-center gap-2"
                              onClick={() => onStatusChange(transaction, option.value)}
                            >
                              <FeatherIcon icon={option.icon} size={14} />
                              {option.label}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </td>
                 <td>
                  <Dropdown
                    isOpen={dropdownOpen[`priority-${transaction.id}`] || false}
                    toggle={() => toggleDropdown(`priority-${transaction.id}`)}
                    direction="down"
                  >
                    <DropdownToggle tag="div" style={{ cursor: "pointer" }}>
                      <span
                        className={`badge rounded-pill py-1 px-2 ${
                          urgencyColors[transaction?.urgencyLevel] || "bg-secondary"
                        }`}
                      >
                        {transaction?.urgencyLevel
                          ? transaction.urgencyLevel.replace(/_/g, " ")
                          : "No Priority"}
                      </span>
                    </DropdownToggle>

                    <DropdownMenu container='body'>
                      {["SEVERE", "HIGH", "MEDIUM", "LOW", "NONE"].map((level) => (
                        <DropdownItem
                          key={level}
                          onClick={() => handlePriorityChange(transaction, level)}
                        >
                          <span
                            className={`badge rounded-pill py-1 px-2 ${urgencyColors[level]}`}
                          >
                            {level.charAt(0) + level.slice(1).toLowerCase()}
                          </span>
                        </DropdownItem>
                      ))}
                      <DropdownItem onClick={() => handlePriorityChange(transaction, "")}>
                        <span className={`badge rounded-pill py-1 px-2 bg-secondary`}>
                          No Priority
                        </span>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </td>
                      <td>
                        <span 
                          className="text-primary cursor-pointer hover-underline"
                          onClick={() => handleDetailsClick('asset', transaction.asset)}
                          style={{ cursor: 'pointer' }}
                        >
                          {transaction?.asset?.assetName}
                        </span>
                      </td>
                      <td>{transaction?.asset?.assetCategory}</td>
                      <td>{transaction?.asset?.serialNumber}</td>
                      <td>{formatCreatedDate(transaction?.firstOccurrence)}</td>
                      <td>
                        <span 
                          className="text-primary cursor-pointer hover-underline"
                          onClick={() => handleDetailsClick('organization', transaction.organization)}
                          style={{ cursor: 'pointer' }}
                        >
                          {transaction?.organization?.name}
                        </span>
                      </td>
                      <td>
                        <span 
                          className="text-primary cursor-pointer hover-underline"
                          onClick={() => handleDetailsClick('location', transaction?.asset?.currentLocation || transaction?.locationName, transaction.organization)}
                          style={{ cursor: 'pointer' }}
                        >
                          {transaction?.asset?.currentLocation || transaction?.locationName}
                        </span>
                      </td>
                      <td>
                        {transaction?.reportedBy?.id ? (
                          <span 
                            className="text-primary cursor-pointer hover-underline"
                            onClick={() => handleReportedByClick(transaction.reportedBy.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            {transaction?.reportedBy?.name}
                          </span>
                        ) : (
                          transaction?.reportedBy?.name || 'N/A'
                        )}
                      </td>
                      <td>
                        {transaction?.assignedTechnician?.id ? (
                          <span 
                            className="text-primary cursor-pointer hover-underline"
                            onClick={() => handleTechnicianClick(transaction.assignedTechnician.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            {transaction?.assignedTechnician?.name}
                          </span>
                        ) : (
                          ''
                        )}
                      </td>
                      <td>
                        <PermissionGuard permission="service:update">
                          <span className='text-warning' role='button' onClick={() => tog_large(transaction)}>
                            <FeatherIcon icon="edit" />
                          </span>
                        </PermissionGuard>
                      </td>
                      <td>
                        <PermissionGuard permission="service:delete">
                          <span
                            className="text-danger"
                            role="button"
                            onClick={() => {
                              setSelectedEntry(transaction);
                              setDeleteModal(true);
                            }}
                          >
                            <FeatherIcon icon="trash-2" />
                          </span>
                        </PermissionGuard>
                      </td>
                    </motion.tr>
                  ))}
                </AnimatePresence>
              </tbody>
            </table>
            
            {loading && (
              <div className="text-center py-3">
                <Spinner color="primary" />
              </div>
            )}

            <div className="d-flex justify-content-center mt-3">
              {hasMore && sortedTransactions.length > 0 ? (
                <Button 
                  color="primary" 
                  onClick={loadMore}
                  disabled={loading}
                >
                  {loading ? 'Loading...' : 'Load More'}
                </Button>
              ) : (
                sortedTransactions.length > 0 && (
                  <div className="text-muted">No more Work Orders to load</div>
                )
              )}
            </div>

            {sortedTransactions.length === 0 && !loading && (
              <div className="text-center py-5 text-muted">
                {searchTerm
                  ? "No Work Orders match your search"
                  : "No Work Orders found"}
              </div>
            )}
          </div>
        </CardBody>
      </Card>

      {/* Sort Modal */}
      <Modal
        isOpen={sortModal}
        toggle={() => setSortModal(false)}
        centered
        className="fade-scale-modal"
        backdropClassName="modal-backdrop-blur"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.2 }}
        >
          <div className="modal-header text-white">
            <h5 className="modal-title fs-4">Sort Work Orders</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setSortModal(false)}
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body p-4">
            <div className="mb-3">
              <label className="form-label fw-medium">Sort By</label>
              <div className="btn-group w-100" role="group">
                <input
                  type="radio"
                  className="btn-check"
                  name="sortField"
                  id="sortCreatedAt"
                  autoComplete="off"
                  checked={sortCriteria.field === 'createdAt'}
                  onChange={() => setSortCriteria({...sortCriteria, field: 'createdAt'})}
                />
                <label className="btn btn-outline-primary" htmlFor="sortCreatedAt">
                  Creation Date
                </label>

                <input
                  type="radio"
                  className="btn-check"
                  name="sortField"
                  id="sortDueDate"
                  autoComplete="off"
                  checked={sortCriteria.field === 'requestDate'}
                  onChange={() => setSortCriteria({...sortCriteria, field: 'requestDate'})}
                />
                <label className="btn btn-outline-primary" htmlFor="sortDueDate">
                  Due Date
                </label>

                <input
                  type="radio"
                  className="btn-check"
                  name="sortField"
                  id="sortPriority"
                  autoComplete="off"
                  checked={sortCriteria.field === 'urgencyLevel'}
                  onChange={() => setSortCriteria({...sortCriteria, field: 'urgencyLevel'})}
                />
                <label className="btn btn-outline-primary" htmlFor="sortPriority">
                  Priority
                </label>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-medium">Sort Direction</label>
              <div className="btn-group w-100" role="group">
                <input
                  type="radio"
                  className="btn-check"
                  name="sortDirection"
                  id="sortAsc"
                  autoComplete="off"
                  checked={sortCriteria.direction === 'asc'}
                  onChange={() => setSortCriteria({...sortCriteria, direction: 'asc'})}
                />
                <label className="btn btn-outline-primary" htmlFor="sortAsc">
                  Ascending
                </label>

                <input
                  type="radio"
                  className="btn-check"
                  name="sortDirection"
                  id="sortDesc"
                  autoComplete="off"
                  checked={sortCriteria.direction === 'desc'}
                  onChange={() => setSortCriteria({...sortCriteria, direction: 'desc'})}
                />
                <label className="btn btn-outline-primary" htmlFor="sortDesc">
                  Descending
                </label>
              </div>
            </div>
          </div>

          <div className="modal-footer bg-light border-top-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => {
                setSortCriteria({ field: 'createdAt', direction: 'desc' });
                setSortModal(false);
              }}
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setSortModal(false)}
            >
              Apply Sort
            </button>
          </div>
        </motion.div>
      </Modal>

      {/* Date Range Modal */}
      <Modal
        isOpen={dateRangeModal}
        toggle={() => setDateRangeModal(false)}
        centered
        className="fade-scale-modal"
        backdropClassName="modal-backdrop-blur"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.2 }}
        >
          <div className="modal-header text-white">
            <h5 className="modal-title fs-4">Select Date Range</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setDateRangeModal(false)}
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body p-4">
            <Row className="g-3">
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="fromDate" className="form-label fw-medium">
                    From Date
                  </label>
                  <DatePicker
                    id="fromDate"
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    selectsStart
                    startDate={fromDate}
                    endDate={toDate}
                    className="form-control"
                    dateFormat="MMMM d, yyyy"
                    placeholderText="Select start date"
                    isClearable
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="toDate" className="form-label fw-medium">
                    To Date
                  </label>
                  <DatePicker
                    id="toDate"
                    selected={toDate}
                    onChange={(date) => setToDate(date)}
                    selectsEnd
                    startDate={fromDate}
                    endDate={toDate}
                    minDate={fromDate}
                    className="form-control"
                    dateFormat="MMMM d, yyyy"
                    placeholderText="Select end date"
                    isClearable
                    disabled={!fromDate}
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div className="modal-footer bg-light border-top-0">
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => {
                clearDateRange();
                setDateRangeModal(false);
              }}
            >
              Clear Dates
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setDateRangeModal(false)}
              disabled={fromDate && !toDate}
            >
              Apply Dates
            </button>
          </div>
        </motion.div>
      </Modal>

      {/* Filter Modal */}
      <Modal
        isOpen={filterModal}
        toggle={() => setFilterModal(false)}
        size="lg"
        className="fade-scale-modal"
        backdropClassName="modal-backdrop-blur"
        centered
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.2 }}
        >
          <div className="modal-header text-white">
            <h5 className="modal-title fs-4">Filter Work Orders</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setFilterModal(false)}
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body p-4">
            <Row className="mb-4 g-3">
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterStatus" className="form-label fw-medium">
                    Status
                  </label>
                  <select
                    id="filterStatus"
                    className="form-select"
                    value={filters.status}
                    onChange={(e) =>
                      setFilters({ ...filters, status: e.target.value })
                    }
                  >
                    <option value="">All Statuses</option>
                    <option value="SUBMITTED">Submitted</option>
                    <option value="IN_PROGRESS">In Progress</option>
                    <option value="RESOLVED">Resolved</option>
                    <option value="ON_HOLD">On Hold</option>
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterImpact" className="form-label fw-medium">
                    Department
                  </label>
                  <select
                    id="filterImpact"
                    className="form-select"
                    value={filters.impactOnCare}
                    onChange={(e) =>
                      setFilters({ ...filters, department: e.target.value })
                    }
                  >
                    {renderSelectOptions("Departments")}
                  </select>
                </div>
              </Col>
            </Row>

            <Row className="mb-4 g-3">
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterImpact" className="form-label fw-medium">
                    Impact on Care
                  </label>
                  <select
                    id="filterImpact"
                    className="form-select"
                    value={filters.impactOnCare}
                    onChange={(e) =>
                      setFilters({ ...filters, impactOnCare: e.target.value })
                    }
                  >
                    {renderSelectOptions("impactOnCare")}
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterIssueType" className="form-label fw-medium">
                    Issue Type
                  </label>
                  <select
                    id="filterIssueType"
                    className="form-select"
                    value={filters.issueType}
                    onChange={(e) =>
                      setFilters({ ...filters, issueType: e.target.value })
                    }
                  >
                    {renderSelectOptions("issueType")}
                  </select>
                </div>
              </Col>
            </Row>

            <Row className="mb-4 g-3">
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterPriority" className="form-label fw-medium">
                    Priority
                  </label>
                  <select
                    id="filterPriority"
                    className="form-select"
                    value={filters.urgencyLevel}
                    onChange={(e) =>
                      setFilters({ ...filters, urgencyLevel: e.target.value })
                    }
                  >
                    {renderSelectOptions("urgencyLevel")}
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterSymptoms" className="form-label fw-medium">
                    Symptoms
                  </label>
                  <select
                    id="filterSymptoms"
                    className="form-select"
                    value={filters.symptomsTags}
                    onChange={(e) =>
                      setFilters({ ...filters, symptomsTags: e.target.value })
                    }
                  >
                    {renderSelectOptions("symptomsTags")}
                  </select>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterUsageStatus" className="form-label fw-medium">
                    Usage Status
                  </label>
                  <select
                    id="filterUsageStatus"
                    className="form-select"
                    value={filters.usageStatus}
                    onChange={(e) =>
                      setFilters({ ...filters, usageStatus: e.target.value })
                    }
                  >
                    {renderSelectOptions("usageStatus")}
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group">
                  <label htmlFor="filterLocation" className="form-label fw-medium">
                    Location
                  </label>
                  <select
                    id="filterLocation"
                    className="form-select"
                    value={filters.organizationLocation}
                    onChange={(e) =>
                      setFilters({ ...filters, organizationLocation: e.target.value })
                    }
                  >
                    <option value="">All Locations</option>
                    {locations?.map((location) => (
                      <option key={location.id} value={location.locationName}>
                        {location.locationName}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            </Row>
          </div>

          <div className="modal-footer bg-light border-top-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => {
                setFilters({
                  status: "",
                  impactOnCare: "",
                  issueType: "",
                  urgencyLevel: "",
                  symptomsTags: "",
                  usageStatus: "",
                  organizationLocation: "",
                });
                setFilterModal(false);
              }}
            >
              Clear All
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                setFilterModal(false);
              }}
            >
              Apply Filters
            </button>
          </div>
        </motion.div>
      </Modal>

      {/* Details Modal */}
      <DetailsModal
        isOpen={detailsModal.isOpen}
        toggle={() => setDetailsModal(prev => ({ ...prev, isOpen: false }))}
        type={detailsModal.type}
        title={detailsModal.title}
        mainData={detailsModal.mainData}
        relatedData={detailsModal.relatedData}
        loading={detailsModal.loading}
        formatCreatedDate={formatCreatedDate}
        onTicketClick={handleTicketClick}
      />

      {/* Ticket Details Modal */}
      <TicketDetailsModal
      isOpen={ticketModal.isOpen}
      enumData={enumData}
      toggle={() => setTicketModal(prev => ({ ...prev, isOpen: false }))}
      ticketData={ticketModal.ticketData}
      loading={ticketModal.loading}
      formatCreatedDate={formatCreatedDate}
      onStatusChange={onStatusChange}
      fetchAssetIssueFromOrganization={fetchAssetIssueFromOrganization}
      />

      <ReportedByModal
        isOpen={reportedByModal.isOpen}
        toggle={() => setReportedByModal(prev => ({ ...prev, isOpen: false }))}
        userData={reportedByModal.userData}
        loading={reportedByModal.loading}
        formatCreatedDate={formatCreatedDate}
        onTicketClick={handleTicketClick}
      />

      <FileModal
        title="Work Orders"
        isOpen={fileModal}
        toggle={() => setFileModal(false)}
        data={transactions}
        onImport={handleImport}
        onExport={handleExport}
        importLabel="Import Work Orders from Excel"
        importNeed={false}
        exportLabel="Export Work Orders to Excel"
      />
      <TechnicianModal
          isOpen={technicianModal.isOpen}
          toggle={() => setTechnicianModal(prev => ({ ...prev, isOpen: false }))}
          technicianData={technicianModal.technicianData}
          loading={technicianModal.loading}
          formatCreatedDate={formatCreatedDate}
          onTicketClick={handleTicketClick}
        />
      {/* Add/Edit Modal */}
<Modal size="lg" isOpen={modal_large} toggle={tog_large}>
  <motion.div
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.9 }}
    transition={{ duration: 0.2 }}
  >
    <div className="modal-header text-white">
      <h5 className="modal-title fs-4">
        {selectedEntry?.id ? 'Edit Work Order' : 'Add Work Order'}
      </h5>
      <button
        type="button"
        className="btn-close btn-close-white"
        onClick={handleModalClose}
        aria-label="Close"
      ></button>
    </div>
    
    <div className="modal-body p-4">
      <form onSubmit={handleUpdate}>
       <Row className="mb-4 g-3">
  <Col md={6}>
    <div className="form-group">
      <label htmlFor="issueType" className="form-label fw-medium">
        Issue Type
      </label>
      <div className="position-relative">
        <select
          id="issueType"
          className={`form-select ${errors.issueType ? 'is-invalid' : ''}`}
          value=""
          onChange={(e) => {
            if (e.target.value) {
              const newValue = [...(selectedEntry?.issueType || []), e.target.value];
              setSelectedEntry({...selectedEntry, issueType: newValue});
            }
          }}
        >
          <option value="">Add Issue Type</option>
          {renderSelectOptions("issueType")}
        </select>
        {errors.issueType && <small className="text-danger">{errors.issueType}</small>}
      </div>
      
      <div className="d-flex flex-wrap gap-2 mt-2">
        {selectedEntry?.issueType?.map((type, index) => (
          <Badge 
            key={index} 
            color="primary" 
            pill 
            className="d-flex align-items-center"
          >
            {type.replace(/_/g, ' ')}
            <button 
              type="button" 
              className="btn-close btn-close-white ms-2" 
              style={{ fontSize: '0.5rem' }}
              onClick={() => {
                const newTypes = selectedEntry.issueType.filter((_, i) => i !== index);
                setSelectedEntry({...selectedEntry, issueType: newTypes});
              }}
              aria-label="Remove"
            />
          </Badge>
        ))}
      </div>
    </div>
  </Col>
  
  <Col md={6}>
    <div className="form-group">
      <label htmlFor="symptomsTags" className="form-label fw-medium">
        Symptoms
      </label>
      <div className="position-relative">
        <select
          id="symptomsTags"
          className={`form-select ${errors.symptomsTags ? 'is-invalid' : ''}`}
          value=""
          onChange={(e) => {
            if (e.target.value) {
              const newValue = [...(selectedEntry?.symptomsTags || []), e.target.value];
              setSelectedEntry({...selectedEntry, symptomsTags: newValue});
            }
          }}
        >
          <option value="">Add Symptoms</option>
          {renderSelectOptions("symptomsTags")}
        </select>
        {errors.symptomsTags && <small className="text-danger">{errors.symptomsTags}</small>}
      </div>
      
      <div className="d-flex flex-wrap gap-2 mt-2">
        {selectedEntry?.symptomsTags?.map((tag, index) => (
          <Badge 
            key={index} 
            color="info" 
            pill 
            className="d-flex align-items-center"
          >
            {tag.replace(/_/g, ' ')}
            <button 
              type="button" 
              className="btn-close btn-close-white ms-2" 
              style={{ fontSize: '0.5rem' }}
              onClick={() => {
                const newTags = selectedEntry.symptomsTags.filter((_, i) => i !== index);
                setSelectedEntry({...selectedEntry, symptomsTags: newTags});
              }}
              aria-label="Remove"
            />
          </Badge>
        ))}
      </div>
    </div>
  </Col>
</Row>

        <Row className="mb-4 g-3">
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="impactOnCare" className="form-label fw-medium">
                Impact on Care
              </label>
              <select
                id="impactOnCare"
                className={`form-select ${errors.impactOnCare ? 'is-invalid' : ''}`}
                value={selectedEntry?.impactOnCare || ''}
                onChange={(e) => setSelectedEntry({...selectedEntry, impactOnCare: e.target.value})}
              >
                <option value="">Select Impact</option>
                {renderSelectOptions("impactOnCare")}
              </select>
              {errors.impactOnCare && <small className="text-danger">{errors.impactOnCare}</small>}
            </div>
          </Col>
          
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="urgencyLevel" className="form-label fw-medium">
                Priority
              </label>
              <select
                id="urgencyLevel"
                className={`form-select ${errors.urgencyLevel ? 'is-invalid' : ''}`}
                value={selectedEntry?.urgencyLevel || ''}
                onChange={(e) => setSelectedEntry({...selectedEntry, urgencyLevel: e.target.value})}
              >
                <option value="">Select Priority</option>
                {renderSelectOptions("urgencyLevel")}
              </select>
              {errors.urgencyLevel && <small className="text-danger">{errors.urgencyLevel}</small>}
            </div>
          </Col>
        </Row>

        <Row className="mb-4 g-3">
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="usageStatus" className="form-label fw-medium">
                Usage Status
              </label>
              <select
                id="usageStatus"
                className={`form-select ${errors.usageStatus ? 'is-invalid' : ''}`}
                value={selectedEntry?.usageStatus || ''}
                onChange={(e) => setSelectedEntry({...selectedEntry, usageStatus: e.target.value})}
              >
                <option value="">Select Usage Status</option>
                {renderSelectOptions("usageStatus")}
              </select>
              {errors.usageStatus && <small className="text-danger">{errors.usageStatus}</small>}
            </div>
          </Col>
           <Col md={6}>
            <div className="form-group">
              <label htmlFor="assignedTechnician" className="form-label fw-medium">
                Assigned Technician
              </label>
             <select
  id="assignedTechnician"
  className={`form-select ${errors.assignedTechnician ? 'is-invalid' : ''}`}
  value={selectedEntry?.assignedTechnician?.id || ''}
  onChange={(e) => {
    const selectedTech = technicians.find(
      (tech) => tech.id === Number(e.target.value) // ✅ Convert to number
    );
    setSelectedEntry({
      ...selectedEntry,
      assignedTechnician: selectedTech || null,
    });
  }}
>
  <option value="">Select Technician</option>
  {technicians?.map((tech) => (
    <option key={tech.id} value={tech.id}>
      {tech.name}
    </option>
  ))}
</select>

              {errors.assignedTechnician && <small className="text-danger">{errors.assignedTechnician}</small>}
            </div>
          </Col>

        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="description" className="form-label fw-medium">
                Description
              </label>
              <input
              type="text"
                id="description"
                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                value={selectedEntry?.description || ''}
                onChange={(e) => setSelectedEntry({...selectedEntry, description: e.target.value})}
                rows={3}
              />
              {errors.description && <small className="text-danger">{errors.description}</small>}
            </div>
          </Col>
                    <Col md={6}>
            <div className="form-group">
              <label htmlFor="requestDate" className="form-label fw-medium">
                Due Date
              </label>
              <DatePicker
                id="requestDate"
                selected={selectedEntry?.requestDate ? new Date(selectedEntry.requestDate) : null}
                onChange={(date) => setSelectedEntry({...selectedEntry, requestDate: date})}
                className="form-control"
                dateFormat="MMMM d, yyyy"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="Time"
              />
            </div>
          </Col>
        </Row>

        {apiError && (
          <div className="alert alert-danger mb-4">
            {apiError}
          </div>
        )}
      </form>
    </div>

    <div className="modal-footer bg-light border-top-0">
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={handleModalClose}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={handleUpdate}
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner size="sm" className="me-2" />
            {selectedEntry?.id ? 'Updating...' : 'Adding...'}
          </>
        ) : (
          selectedEntry?.id ? 'Update' : 'Add'
        )}
      </button>
    </div>
  </motion.div>
</Modal>
  {/* Delete Confirmation Modal */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
        <div className="modal-header">
          <h5 className="modal-title">Confirm Delete</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete this work order? This action cannot be
            undone.
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Transactions;